(() => {
  const root = document.getElementById('oppo-cart-modal');
  if (!root) return;

  const panel = root.querySelector('.oppo-cart-modal__panel');
  const title = root.querySelector('.oppo-cart-modal__title');
  const loginText = root.querySelector('.oppo-cart-modal__login-text');
  const status = root.querySelector('.oppo-cart-modal__status');
  const itemsContainer = root.querySelector('.oppo-cart-modal__items');
  const footer = root.querySelector('.oppo-cart-modal__footer');
  const totalLabel = root.querySelector('.oppo-cart-modal__total-label');
  const totalValue = root.querySelector('.oppo-cart-modal__total-value');
  const savings = root.querySelector('.oppo-cart-modal__savings');
  const shipping = root.querySelector('.oppo-cart-modal__shipping');
  const viewCartButton = root.querySelector('.oppo-cart-modal__button--secondary');
  const checkoutButton = root.querySelector('.oppo-cart-modal__button--primary');
  let lastFocused = null;
  let requestId = 0;

  const text = (key) => root.dataset[key] || '';
  const shopRoot = window.Shopify?.routes?.root || '/';
  const cartJsonUrl = `${shopRoot.replace(/\/?$/, '/')}cart.js`;
  const cartAddUrl = `${shopRoot.replace(/\/?$/, '/')}cart/add.js`;
  const cartChangeUrl = `${shopRoot.replace(/\/?$/, '/')}cart/change.js`;

  function isProductAddForm(form) {
    if (form.matches('body > form.oppo-sticky-buy-form')) return true;

    const productPage = document.querySelector('main[data-template^="product"]');
    if (!productPage || !productPage.contains(form)) return false;

    return (
      form.matches('form[data-type="add-to-cart-form"]') &&
      Boolean(form.querySelector('input[name="product-id"]'))
    );
  }

  function money(cents, currency) {
    const locale = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency || 'EUR'}`;
    }
  }

  function closeNativeDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer?.close) drawer.close();
  }

  function show() {
    closeNativeDrawer();
    if (root.hidden) {
      lastFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    }
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-oppo-cart-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('oppo-cart-modal-open');
    requestAnimationFrame(() => panel?.focus({ preventScroll: true }));
  }

  function close() {
    if (root.hidden) return;
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-oppo-cart-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('oppo-cart-modal-open');
    lastFocused?.focus?.({ preventScroll: true });
  }

  function element(tag, className, value) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  }

  function itemImageUrl(item) {
    if (!item.image) return '';
    const joiner = item.image.includes('?') ? '&' : '?';
    return `${item.image}${joiner}width=160`;
  }

  function productUrl(item) {
    if (item.handle) {
      return `${shopRoot.replace(/\/?$/, '/')}products/${encodeURIComponent(item.handle)}`;
    }
    return item.url || root.dataset.cartUrl;
  }

  function isGift(item) {
    return Number(item.final_line_price) === 0 && Number(item.original_line_price) > 0;
  }

  function cartActionButton(action, item, label, content) {
    const button = element('button', `oppo-cart-modal__quantity-button oppo-cart-modal__quantity-button--${action}`);
    button.type = 'button';
    button.dataset.oppoCartChange = action;
    button.dataset.lineKey = item.key;
    button.dataset.quantity = String(item.quantity);
    button.setAttribute('aria-label', label);
    button.innerHTML = content;
    return button;
  }

  function renderItem(item, currency) {
    const row = element('article', 'oppo-cart-modal__item');
    const imageLink = element('a', 'oppo-cart-modal__image-link');
    imageLink.href = productUrl(item);

    if (item.image) {
      const image = element('img', 'oppo-cart-modal__image');
      image.src = itemImageUrl(item);
      image.alt = item.product_title || item.title || '';
      image.width = 124;
      image.height = 144;
      image.loading = 'eager';
      imageLink.append(image);
    }

    const details = element('div', 'oppo-cart-modal__details');
    const productTitle = element('a', 'oppo-cart-modal__product-title', item.product_title || item.title || '');
    productTitle.href = productUrl(item);
    details.append(productTitle);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      details.append(element('p', 'oppo-cart-modal__variant', item.variant_title));
    }

    const isGreek = document.documentElement.lang === 'el';

    if (isGift(item)) {
      const giftControls = element('div', 'oppo-cart-modal__gift-controls');
      const badge = element('span', 'oppo-cart-modal__gift', text('gift'));
      const quantity = element('span', 'oppo-cart-modal__quantity', `×${item.quantity}`);
      const remove = cartActionButton(
        'remove',
        item,
        isGreek ? 'Αφαίρεση δώρου' : 'Remove gift',
        '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5"/></svg>'
      );
      giftControls.append(badge, quantity, remove);
      details.append(giftControls);
    } else {
      const controls = element('div', 'oppo-cart-modal__quantity-controls');
      const decrease = cartActionButton('decrease', item, isGreek ? 'Μείωση ποσότητας' : 'Decrease quantity', '−');
      decrease.disabled = Number(item.quantity) <= 1;
      const value = element('span', 'oppo-cart-modal__quantity-value', String(item.quantity));
      value.setAttribute('aria-live', 'polite');
      const increase = cartActionButton('increase', item, isGreek ? 'Αύξηση ποσότητας' : 'Increase quantity', '+');
      const remove = cartActionButton(
        'remove',
        item,
        isGreek ? 'Αφαίρεση προϊόντος' : 'Remove product',
        '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5"/></svg>'
      );
      controls.append(decrease, value, increase, remove);
      details.append(controls);
    }

    const price = element('div', 'oppo-cart-modal__price');
    if (Number(item.original_line_price) > Number(item.final_line_price)) {
      price.append(element('span', 'oppo-cart-modal__compare-price', money(item.original_line_price, currency)));
    }
    price.append(document.createTextNode(Number(item.final_line_price) === 0 ? (document.documentElement.lang === 'el' ? 'Δωρεάν' : 'Free') : money(item.final_line_price, currency)));

    row.append(imageLink, details, price);
    return row;
  }

  function render(cart) {
    const count = Number(cart.item_count || 0);
    const currency = cart.currency || 'EUR';
    const cartIcon = document.querySelector('cart-icon');
    cartIcon?.renderCartBubble?.(count);
    title.textContent = `${text('title')} (${count})`;
    if (loginText) loginText.textContent = text('login');
    itemsContainer.replaceChildren();

    if (!count) {
      status.textContent = text('empty');
      footer.hidden = true;
      return;
    }

    status.textContent = '';
    const fragment = document.createDocumentFragment();
    for (const item of cart.items || []) fragment.append(renderItem(item, currency));
    itemsContainer.append(fragment);

    totalLabel.textContent = text('total');
    totalValue.textContent = money(cart.total_price, currency);
    shipping.textContent = text('shipping');
    viewCartButton.textContent = text('viewCart');
    viewCartButton.href = root.dataset.cartUrl;
    checkoutButton.textContent = text('checkout');
    checkoutButton.href = root.dataset.checkoutUrl;

    const saved = Math.max(0, Number(cart.items_subtotal_price || 0) - Number(cart.total_price || 0));
    savings.hidden = saved <= 0;
    savings.textContent = saved > 0 ? `${text('savings')} ${money(saved, currency)}` : '';
    footer.hidden = false;

  }

  async function changeItem(lineKey, quantity) {
    root.setAttribute('aria-busy', 'true');
    root.querySelectorAll('[data-oppo-cart-change]').forEach((button) => {
      button.disabled = true;
    });

    try {
      const response = await fetch(cartChangeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: lineKey, quantity }),
      });
      const cart = await response.json();
      if (!response.ok || cart.status) {
        throw new Error(cart.description || cart.message || 'Unable to update cart');
      }
      render(cart);
    } catch (error) {
      status.textContent = error instanceof Error
        ? error.message
        : (document.documentElement.lang === 'el' ? 'Δεν ήταν δυνατή η ενημέρωση του καλαθιού.' : 'The cart could not be updated.');
    } finally {
      root.removeAttribute('aria-busy');
    }
  }

  async function refresh({ openAfter = false } = {}) {
    const currentRequest = ++requestId;
    if (openAfter) {
      status.textContent = text('loading');
      itemsContainer.replaceChildren();
      footer.hidden = true;
      show();
    }

    try {
      const response = await fetch(cartJsonUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      const cart = await response.json();
      if (currentRequest !== requestId) return;
      render(cart);
      if (openAfter && root.hidden) show();
    } catch (_error) {
      if (currentRequest !== requestId) return;
      status.textContent = document.documentElement.lang === 'el'
        ? 'Δεν ήταν δυνατή η φόρτωση του καλαθιού.'
        : 'The cart could not be loaded.';
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const changeButton = target?.closest('[data-oppo-cart-change]');
    if (changeButton) {
      event.preventDefault();
      const currentQuantity = Number(changeButton.dataset.quantity || 0);
      const action = changeButton.dataset.oppoCartChange;
      const nextQuantity = action === 'increase'
        ? currentQuantity + 1
        : action === 'decrease'
          ? Math.max(1, currentQuantity - 1)
          : 0;
      changeItem(changeButton.dataset.lineKey || '', nextQuantity);
      return;
    }

    const trigger = target?.closest('[data-oppo-cart-trigger], [data-testid="cart-drawer-trigger"]');
    if (trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      refresh({ openAfter: true });
      return;
    }

    if (target?.closest('[data-oppo-cart-close]')) close();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || !isProductAddForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitter = event.submitter instanceof HTMLButtonElement ? event.submitter : null;
    if (submitter?.disabled) return;

    submitter?.setAttribute('aria-busy', 'true');
    if (submitter) submitter.disabled = true;

    let release;
    try {
      release = window.OppoGift?.begin();
      const mainProductId = form.dataset.oppoStickyProductId || new FormData(form).get('product-id')?.toString() || '';
      const { formData, giftInput } = window.OppoGift
        ? await window.OppoGift.prepare(form, mainProductId)
        : { formData: new FormData(form), giftInput: null };
      const requestHeaders = {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      };
      let requestBody = formData;

      if (giftInput?.dataset.oppoGiftVariantId) {
        const mainProperties = {};
        for (const [key, value] of formData.entries()) {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (propertyMatch && typeof value === 'string' && value !== '') {
            mainProperties[propertyMatch[1]] = value;
          }
        }

        const mainItem = {
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity')) || 1,
        };
        if (Object.keys(mainProperties).length > 0) mainItem.properties = mainProperties;
        if (formData.get('selling_plan')) mainItem.selling_plan = Number(formData.get('selling_plan'));

        requestHeaders['Content-Type'] = 'application/json';
        requestBody = JSON.stringify({
          items: [
            mainItem,
            {
              id: Number(giftInput.dataset.oppoGiftVariantId),
              quantity: 1,
              properties: {
                _oppo_gift_for: mainProductId,
                _oppo_gift_title: giftInput.dataset.oppoGiftTitle || '',
              },
            },
          ],
        });
      }

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: requestHeaders,
        body: requestBody,
      });

      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add product');
      }

      await refresh({ openAfter: true });
    } catch (error) {
      status.textContent = error instanceof Error
        ? error.message
        : (document.documentElement.lang === 'el' ? 'Δεν ήταν δυνατή η προσθήκη στο καλάθι.' : 'The product could not be added.');
      itemsContainer.replaceChildren();
      footer.hidden = true;
      show();
    } finally {
      release?.();
      submitter?.removeAttribute('aria-busy');
      if (submitter) submitter.disabled = false;
    }
  }, true);

  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add') {
      if (!root.hidden) event.promise?.then(() => refresh());
      return;
    }

    if (event.promise) {
      event.promise
        .then((result) => {
          if (!result?.detail?.didError) refresh({ openAfter: true });
        })
        .catch(() => {});
    } else {
      window.setTimeout(() => refresh({ openAfter: true }), 250);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key === 'Tab' && panel) {
      const focusable = Array.from(
        panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((node) => !node.hasAttribute('hidden'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  title.textContent = `${text('title')} (0)`;
  totalLabel.textContent = text('total');
  shipping.textContent = text('shipping');
  viewCartButton.textContent = text('viewCart');
  checkoutButton.textContent = text('checkout');
})();